import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

import { ComponentsModule } from '@ldw/components';
import { RoesbergModule } from '@ldw/roesberg';

import { SharedModule } from '../shared/shared.module';
import { DocumentsModule } from '../documents/documents.module';
import { BookmarksModule } from '../bookmarks/bookmarks.module';

import { ViewModeDirective } from './view-mode.directive';

/* navigation and components */
import { MainNavigationComponent } from './main-navigation.component';
import {
  BottomNavigationComponent,
  SidebarNavigationComponent,
  TopbarNavigationComponent,
  InfoBottomSheetComponent,
  UserBottomSheetComponent,
} from './navigation';
import { SettingsPageComponent } from './settings/settings-page.component';
import { LogoComponent } from './components';
import { LogOutComponent } from './log-out/log-out.component';
import { LoginComponent } from './login/login.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MenuComponent } from './components/menu/menu.component';
import { MessagesButtonComponent } from '../messages/messages-button/messages-button.component';
import { MatBadgeModule } from '@angular/material/badge';
import { MessagesPageComponent } from './messages/messages-page.component';
import { MessagesModule } from '../messages/messages.module';
import { ErrorPageComponent } from './error-page/error-page.component';
import { ManualPageComponent } from './manual/manual-page.component';
import { PdfViewModule } from '../pdf/pdf-view.module';
import { AuthFailedComponent } from './auth-failed/auth-failed.component';

@NgModule({
  declarations: [
    SidebarNavigationComponent,
    MainNavigationComponent,
    TopbarNavigationComponent,
    BottomNavigationComponent,
    SettingsPageComponent,
    LogoComponent,
    ViewModeDirective,
    LogOutComponent,
    LoginComponent,
    InfoBottomSheetComponent,
    UserBottomSheetComponent,
    MenuComponent,
    MessagesButtonComponent,
    MessagesPageComponent,
    ErrorPageComponent,
    ManualPageComponent,
    AuthFailedComponent
  ],
  exports: [MainNavigationComponent],
  imports: [
    BookmarksModule,
    CommonModule,
    MatIconModule,
    MatToolbarModule,
    MatTooltipModule,
    MatMenuModule,
    RouterModule,
    MatSidenavModule,
    MatListModule,
    SharedModule,
    MatCardModule,
    ComponentsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatRadioModule,
    MatCheckboxModule,
    MatButtonModule,

    RoesbergModule,
    DocumentsModule,
    MatProgressBarModule,
    MatBadgeModule,
    MessagesModule,
    PdfViewModule,
  ],
})
export class ShellModule {}
